// Carriers
export const CARRIERS_FETCHED = 'CARRIERS_FETCHED';
export function carriersFetched(top10CarriersReport) {
  return {
    type: CARRIERS_FETCHED,
    top10CarriersReport: top10CarriersReport,
  };
}
export const CARRIERS_REQUEST_STARTED = 'CARRIERS_REQUEST_STARTED';
export function carriersRequestStarted() {
  return {
    type: CARRIERS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const CARRIERS_REQUEST_ERROR = 'CARRIERS_REQUEST_ERROR';
export function carriersRequestError() {
  return {
    type: CARRIERS_REQUEST_ERROR,
  };
}
